__turbopack_context__.v({
  "content": "FileSpinner-module-scss-module__PNlqFG__content",
});
